// @flow
import { ACTIONS } from '../constants';
import getNotifications from '../api/getNotifications';
import * as AppState from '../../../state/reducer/app/appState';

const loadNotifications = () => async (dispatch: Function) => {
    AppState.setLoading();
    const notifications = await getNotifications();

    dispatch({
        type: ACTIONS.NOTIFICATIONS_LOADED,
        notifications
    });
    AppState.stopLoading();
};

export default loadNotifications;



// WEBPACK FOOTER //
// ./src/v5/notifications/state/loadNotifications.js